export default "/images/7cff7ce515293aa8c96187187a7e6cdc.avif";